import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { loadingTrue, loadingFalse } from "../../Reducer/loaderSlice";
import Handler from "../../Helpers/Handler";
import { useParams, useNavigate } from "react-router-dom";

const VehicleView = () => {

    const { id } = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [vehicle, setVehicle] = useState(null);
    const [stats, setStats] = useState(null);

    const loadVehicle = async () => {
        dispatch(loadingTrue());

        const res = await Handler({
            method: "get",
            url: `/vehicle/view.php?id=${id}`
        });

        if (res.success) {
            setVehicle(res.data.vehicle_info);
            setStats(res.data.statistics);
        }

        dispatch(loadingFalse());
    };

    useEffect(() => { loadVehicle() }, []);

    return (
        <div className="page-card">

            <div className="page-header">
                <h4>Vehicle Details</h4>
                <button className="btn add-btn" onClick={() => navigate("/vehicles")}>Back</button>
            </div>

            {/* VEHICLE INFO */}
            <div className="info-grid mb-4">

                <div className="info-item">
                    <i className='bx bx-car'></i>
                    <div>
                        <span>Vehicle Number</span>
                        <strong className="text-uppercase">{vehicle?.vehicle_number}</strong>
                    </div>
                </div>

                <div className="info-item">
                    <i className='bx bx-truck'></i>
                    <div>
                        <span>Lorry Type</span>
                        <strong>{vehicle?.lorry_type}</strong>
                    </div>
                </div>

                <div className="info-item">
                    <i className='bx bx-package'></i>
                    <div>
                        <span>Capacity</span>
                        <strong>{vehicle?.capacity}</strong>
                    </div>
                </div>

                <div className="info-item">
                    <i className='bx bx-check-circle'></i>
                    <div>
                        <span>Status</span>
                        <strong className={`vehicle-status-badge text-capitalize ${vehicle?.status}`}>
                            {vehicle?.status?.replace("_", " ")}
                        </strong>
                    </div>
                </div>

            </div>

            {/* ⭐ KPI GRADIENT CARDS (4 + 4) */}
            <div className="kpi-grid">

                <div className="kpi-card gradient-blue">
                    <span>Total Dispatch</span>
                    <strong>{stats?.total_dispatch_assigned}</strong>
                </div>

                <div className="kpi-card gradient-purple">
                    <span>Total Trips</span>
                    <strong>{stats?.total_trip_logs}</strong>
                </div>

                <div className="kpi-card gradient-green">
                    <span>Drivers Used</span>
                    <strong>{stats?.unique_drivers_used}</strong>
                </div>

                <div className="kpi-card gradient-orange">
                    <span>Total Hours</span>
                    <strong>{stats?.total_hours}</strong>
                </div>

                <div className="kpi-card gradient-pink">
                    <span>Normal Hours</span>
                    <strong>{stats?.normal_hours}</strong>
                </div>

                <div className="kpi-card gradient-cyan">
                    <span>OT Hours</span>
                    <strong>{stats?.ot_hours}</strong>
                </div>

                <div className="kpi-card gradient-red">
                    <span>Peak Hours</span>
                    <strong>{stats?.peak_hours}</strong>
                </div>

                <div className="kpi-card gradient-dark">
                    <span>Weekend + Holiday</span>
                    <strong>
                        {(stats?.weekend_hours || 0) + (stats?.holiday_hours || 0)}
                    </strong>
                </div>

            </div>

        </div>
    );
};

export default VehicleView;
